<template>
  <navbar :show-navbar="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-icon btn-round" @click="minimizeSidebar">
          <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
          <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
        </button>
      </div>

      <a class="navbar-brand">{{contentTitle}}</a>
    </div>

    <template slot="navbar-menu">
        <p-button class="btn btn-facebook" @click="redirectCourses()">
            <i class="fas fa-chalkboard fa-lg"></i>   Register for a Class
        </p-button>
        <p-button class="btn btn-facebook" @click="redirectReservations()">
            <i class="fas fa-calendar-alt fa-lg"></i>   Make a Reservation
        </p-button>
        <p-button class="btn btn-facebook" @click="signOutOidc">
            <i class="fas fa-sign-out-alt fa-lg"></i>   Sign out
        </p-button>
    </template>
  </navbar>
</template>
<script>
  import { Navbar, NavbarToggleButton, Button } from '@/components/UIComponents'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    components: {
        Navbar,
        NavbarToggleButton,
        [Button.name]: Button
    },
    props: {
      contentTitle: {
        type: String,
        required: false,
        default: 'MyAileron'
      }
    },
      computed: {
          ...mapGetters('oidcStore', [
              'oidcIsAuthenticated',
              'oidcAuthenticationIsChecked',
              'oidcUser',
              'oidcIdToken',
              'oidcIdTokenExp'
          ]),
      },
    data() {
      return {
        activeNotifications: false,
        showNavbar: false
      }
    },
    methods: {
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },
        toggleNotificationDropDown() {
            this.activeNotifications = !this.activeNotifications
        },
        closeDropDown() {
            this.activeNotifications = false
        },
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
        },
        hideSidebar() {
            this.$sidebar.displaySidebar(false)
        },
        minimizeSidebar() {
            this.$sidebar.toggleMinimize()
        },
        toggleNavbar() {
            this.showNavbar = !this.showNavbar;
        },
        redirectCourses() {
            window.open(process.env.VUE_APP_REGISTRATION_REDIRECT, "_blank");
        },
        redirectReservations() {
            window.open(process.env.VUE_APP_RESERVATION_REDIRECT, "_blank");
        },
        ...mapActions('oidcStore', [
            'signOutOidc'
        ])
    }
  }
</script>
<style lang="css" scoped>
    .navbar-custom {
        -webkit-box-shadow: none;
        box-shadow: none;
        border-bottom: 1px solid #2f2b2b;
        background-color: cadetblue;
    }
</style>
